import type { AxiosRequestConfig } from 'axios'
import { httpClient } from '@/infra/http/httpClient'

/**
 * Orval mutator — routes all generated API calls through the shared httpClient.
 * This ensures every request inherits:
 *  - Bearer token injection
 *  - Accept-Language header
 *  - 401 silent refresh / logout behaviour
 *  - Datadog error logging
 */
export const customInstance = async <T>(config: AxiosRequestConfig): Promise<T> => {
  try {
    const { data } = await httpClient<T>(config)
    return data
  } catch (e) {
    console.error(e)
    throw e
  }
}
